import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import style from "./InvoiceList.module.css";
import { fetchInvoiceList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import { DatePicker } from "antd";
import invoiceIcon from "../../../assets/images/invoice-page-icon.svg";
import { formatNumberToCurrency } from "../../../utils/CommonUtil";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class InventoryInvoice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      dateFrom: "",
      dateTo: "",
      status: "",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      invoiceList: []
    };
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
   // document.title = 'Inventory Invoices - TechToMedix';
   await this.props.fetchInvoiceList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.invoiceListData && 
      this.props.invoiceListData.invoiceList && 
      this.props.invoiceListData.invoiceList.invoice){

        this.setState({
          invoiceList: this.props.invoiceListData.invoiceList.invoice
        })
    }
    setTimeout(() => {
      if (this.props.invoiceListData.invoiceList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
        setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
        }, 500);
      }
    }, 1000);
  }

  callInvoiceListAPI = async() => {
    this.setState({
      invoiceList: []
    })
    const payload = this.getPayload();
    await this.props.fetchInvoiceList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      payload
    );
    if(this.props.invoiceListData && 
      this.props.invoiceListData.invoiceList && 
      this.props.invoiceListData.invoiceList.invoice){

        this.setState({
          invoiceList: this.props.invoiceListData.invoiceList.invoice
        })
    }

    if(!this.props.invoiceListData.loading){
      this.setState({
        invoiceList: this.props.invoiceListData.invoiceList.invoice
      })
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
    }, 1000);
    }

  }

    /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
    dateFrom: dateFormatter(this.state.dateFrom),
    dateTo: dateFormatter(this.state.dateTo),
    status: this.state.status
    };
  };
  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        <Link title="View Invoice" to={{ pathname: `/app/invoicedetails/${row.invoice_id}` }}>
        <img src={invoiceIcon} alt="invoice icon" width="15px" />
        </Link>
      </div>
    );
  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callInvoiceListAPI();
    });
  };

  onSearchChange = (event) => {
    this.setState({ searchKey: event.target.value, page: 1, isDataFetched: false },()=>{
      this.callInvoiceListAPI();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ page, isDataFetched: false },()=>{
      this.callInvoiceListAPI();
    });
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }
  
  /**
   * This method will be called when date from filter is changed.
   */
  handleDateFrom = (date) => {
    this.setState(
      {
        dateFrom: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callInvoiceListAPI();
      }
    );
  };

  /**
   * This method will be called when date to filter is changed.
   */
  handleDateTo = (date) => {
    this.setState(
      {
        dateTo: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callInvoiceListAPI();
      }
    );
  };

  clearFilters = () => {
    this.setState({
      searchKey: "",
      sortBy: "",
      sortName: undefined,
      sortOrder: undefined,
      status: "",
      dateFrom: "",
      dateTo: "",
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callInvoiceListAPI();
    });
  }

  
  onSelect = (event) => {
    this.setState({ status: event.target.value, page: 1, isDataFetched: false },()=>{
      this.callInvoiceListAPI();
    });
  };



  checkValidData = (data) => {
      if(!data){
        return "Not Available";
      }
      return data;
  }

  render() {
    const invoiceList = this.props.invoiceListData.invoiceList;

    const status_list = this.props.dropdownListData &&
    this.props.dropdownListData.dropdownList && this.props.dropdownListData.dropdownList.lk_invoice_status;

    const status_list_Options = status_list 
    && status_list.map((element, index) => (
     <option key={index} value={element.lk_invoice_status_id}>
       {element.status}
     </option>
   ));


    return (
      <div className={style.invoiceListMainWrapper}>
        <div className="row">
          {/* <div className="col-lg-7">
            <h3>Invoice List</h3>
          </div> */}
          <div
                className="col-sm-6 col-md-6 col-lg-3"
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
                <div className="col-sm-6 col-md-6 col-lg-3">
              <DatePicker
                name="dateFrom"
                onChange={this.handleDateFrom}
                placeholder="Date From"
                className="form-control"
                value={this.state.dateFrom}
                disabledDate={(d) => !d || d.isAfter(this.state.dateTo)}
              />
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3">
              <DatePicker
                name="dateTo"
                onChange={this.handleDateTo}
                placeholder="Date To"
                className="form-control"
                value={this.state.dateTo}
                disabledDate={(d) => !d || d.isBefore(this.state.dateFrom)}
              />
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3">
              <select
                    className="form-control"
                    id="status"
                    onChange={this.onSelect}
                    value={this.state.status}
                  >
                    <option value="">Select Status</option>
                    {status_list_Options}
                  </select>
            </div>
            </div>
            <div className="row mb-1 d-flex">
            <div className="col-md-12 order-3 order-md-2 justify-content-md-end">
              <p className={style.clearFilters} onClick={this.clearFilters}>Clear Filters</p>
            </div>
            </div>
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.invoiceList}
          version="4"
          search={false}
          pagination
          fetchInfo={{
            dataTotalSize: this.props.invoiceListData.invoiceList.total,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader(),
          }}
        >
          <TableHeaderColumn dataField="invoice_id" isKey dataSort={true}>
            Invoice No.
          </TableHeaderColumn>
          <TableHeaderColumn dataField="billTo" dataSort={true}>
            Supplier Name
          </TableHeaderColumn>
          <TableHeaderColumn
          dataField="" 
            dataFormat={this.checkValidData} dataSort={true}>
            Product Name
          </TableHeaderColumn>
          <TableHeaderColumn 
          dataField="total" 
          dataAlign="right"
           dataFormat={formatNumberToCurrency} 
          dataSort={true}>
            Amount (ZAR)
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="invoice_date"
            dataSort={true}
            dataFormat={dateFormatter}
          >
            Date
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="status"
            dataSort={true}
            dataFormat={this.checkValidData}
          >
            Status
          </TableHeaderColumn>

         { checkIfPermitted(Permissions.VIEW_INVOICE) && ( 
         <TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            dataAlign="center"
            width="10%"
          >
            Actions
          </TableHeaderColumn>)}
        </BootstrapTable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    invoiceListData: state.invoiceList,
    dropdownListData: state.dropdownList, 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoiceList: (searchKey, sortBy, page, payload) =>
      dispatch(fetchInvoiceList(searchKey, sortBy, page,payload, 3)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryInvoice);
